import { render, staticRenderFns } from "./Gekko.vue?vue&type=template&id=80f0de9c&"
import script from "./Gekko.vue?vue&type=script&lang=js&"
export * from "./Gekko.vue?vue&type=script&lang=js&"
import style0 from "./Gekko.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports